import * as React from 'react'
import {
    IconCsv,
    IconDoc,
    IconDocx,
    IconJpeg,
    IconJpg,
    IconMov,
    IconMp4,
    IconPdf,
    IconPng,
    IconPpt,
    IconPptx,
    IconUnknown,
    IconWebm,
    IconXls,
    IconXlsx,
} from '../../../shared/components/svg'
import type { FileExtension } from '../../../shared/domain/files/fileExtensions.no-deps'

export function FileExtensionIcon(props: { fileExtension: FileExtension; isGrayscale: boolean }) {
    switch (props.fileExtension) {
        case '.csv':
            return <IconCsv isGrayscale={props.isGrayscale} />
        case '.doc':
            return <IconDoc isGrayscale={props.isGrayscale} />
        case '.docx':
            return <IconDocx isGrayscale={props.isGrayscale} />
        case '.jpeg':
            return <IconJpeg isGrayscale={props.isGrayscale} />
        case '.jpg':
            return <IconJpg isGrayscale={props.isGrayscale} />
        case '.mov':
            return <IconMov isGrayscale={props.isGrayscale} />
        case '.mp4':
            return <IconMp4 isGrayscale={props.isGrayscale} />
        case '.pdf':
            return <IconPdf isGrayscale={props.isGrayscale} />
        case '.png':
            return <IconPng isGrayscale={props.isGrayscale} />
        case '.ppt':
            return <IconPpt isGrayscale={props.isGrayscale} />
        case '.pptx':
            return <IconPptx isGrayscale={props.isGrayscale} />
        case '.webm':
            return <IconWebm isGrayscale={props.isGrayscale} />
        case '.xls':
            return <IconXls isGrayscale={props.isGrayscale} />
        case '.xlsx':
            return <IconXlsx isGrayscale={props.isGrayscale} />
        default:
            return <IconUnknown />
    }
}
